export const GOAL_OPTIONS = [
  { value: 'ege', label: 'ЕГЭ' },
  { value: 'oge', label: 'ОГЭ' },
  { value: 'oge_ege', label: 'ОГЭ + ЕГЭ' },
  { value: 'other', label: 'Другое' },
];

export const EGE_YEAR_OPTIONS = [
  { value: '2027', label: '2027' },
  { value: '2028', label: '2028' },
  { value: 'other', label: 'Другое' },
];

export const SCORE_OPTIONS = [
  { value: '100', label: '100' },
  { value: '90plus', label: '90+' },
  { value: '80plus', label: '80+' },
  { value: '70plus', label: '70+' },
  { value: 'threshold', label: 'Пройти порог' },
];

export const HOMEWORK_OPTIONS = [
  { value: 'always_careful', label: 'Всегда делаю старательно' },
  { value: 'try_fully', label: 'Стараюсь делать полностью' },
  { value: 'hard_to_force', label: 'Сложно себя заставить' },
];

export const WORKLOAD_OPTIONS = [
  { value: 'high', label: 'Высокая (очень мало времени остается)' },
  { value: 'medium', label: 'Средняя' },
  { value: 'low', label: 'Низкая' },
];

export const GROUP_OPTIONS = [
  { value: 'interested', label: 'Интересно' },
  { value: 'can_try', label: 'Можно попробовать' },
  { value: 'need_think', label: 'Может быть, надо подумать' },
  { value: 'no', label: 'Категорически нет, не важно что это за группы' },
];

export const FINANCE_OPTIONS = [
  { value: 'max_efficiency', label: 'Выбираем по максимальной эффективности' },
  { value: 'balance', label: 'Разумный баланс цена / качество' },
  { value: 'cheaper', label: 'Хотелось бы подешевле, но без потери баллов' },
  { value: 'consultations', label: 'Есть возможность оплачивать эпизодические консультации, не более' },
  { value: 'none', label: 'Нет возможности оплачивать совсем' },
];

export const LESSON_WAIT_OPTIONS = [
  { value: 'ok_think', label: 'Нормально: как раз успеваю сам подумать' },
  { value: 'ok_short', label: 'Нормально, если ненадолго; долгие паузы выбивают' },
  { value: 'need_focus', label: 'Тяжело ждать — лучше, когда внимание только на мне' },
];

export const LESSON_THINK_OPTIONS = [
  { value: 'long_silence', label: 'Дайте помолчать подольше — сам докручу' },
  { value: 'short_hint', label: 'Короткая пауза, потом намёк' },
  { value: 'together_asap', label: 'Лучше сразу разбирать вместе, иначе застреваю' },
];

export const LESSON_SPOIL_OPTIONS = [
  { value: 'want_self', label: 'Жалко — хотел сам дойти' },
  { value: 'ok_understand', label: 'Нормально, главное понять ход' },
  { value: 'prefer_explain', label: 'Даже лучше: сам бы долго крутился впустую' },
];

export const LESSON_CHECK_OPTIONS = [
  { value: 'alone_end', label: 'Условие — и сам; проверьте в конце или когда попрошу' },
  { value: 'each_step', label: 'Сверяться после каждого шага — так спокойнее' },
  { value: 'plan_then', label: 'Сначала вместе план, дальше сам' },
];

export const LESSON_SPEAK_OPTIONS = [
  { value: 'aloud', label: 'Проговаривать вслух, что думаю' },
  { value: 'silent_then', label: 'Думать молча, говорить когда уже есть мысль' },
  { value: 'write_min', label: 'Писать / печатать; голосом минимум' },
];

export const LESSON_PRAISE_OPTIONS = [
  { value: 'encourage', label: 'Подбадривайте и за небольшие шаги — так проще не сдаваться' },
  {
    value: 'only_real',
    label: 'Хвалите только когда правда хорошо получилось, иначе неловко или раздражает',
  },
  { value: 'concrete', label: 'Без «молодец»: скажите конкретно, что ок и что поправить' },
];

export const LESSON_TONE_OPTIONS = [
  { value: 'lively', label: 'Живой, можно шутить, если не сбивает с задачи' },
  { value: 'calm', label: 'Спокойный и ровный, без лишнего веселья' },
  { value: 'dry', label: 'Сухой и по делу; «на позитиве» скорее мешает' },
];

export const HOMEWORK_INCOMPLETE_OPTIONS = [
  { value: 'send_partial', label: 'Пришлю как есть и напишу, где застрял' },
  { value: 'finish_later', label: 'Доделаю потом, даже после занятия — бросить кусок не могу' },
  { value: 'may_drop', label: 'Могу не сдать или забросить, если не хватило сил или застрял' },
];

export const WORK_STYLE_FIELDS = [
  'lesson_wait',
  'lesson_think_time',
  'lesson_spoil',
  'lesson_step_check',
  'lesson_speak',
  'lesson_praise',
  'lesson_tone',
  'homework_incomplete',
];

export const WORK_STYLE_QUESTIONS = [
  {
    field: 'lesson_wait',
    legend: '8.1. Ожидание, пока преподаватель с другим',
    prompt: 'Когда на занятии я на пару минут ухожу к другому ученику, вам обычно:',
    options: LESSON_WAIT_OPTIONS,
  },
  {
    field: 'lesson_think_time',
    legend: '8.2. Сколько тишины дать',
    prompt: 'Если задача не сразу получается:',
    options: LESSON_THINK_OPTIONS,
  },
  {
    field: 'lesson_spoil',
    legend: '8.3. Когда объясняют решение, хотя ещё думал',
    prompt: 'Если я начинаю объяснять, а вы ещё думали:',
    options: LESSON_SPOIL_OPTIONS,
  },
  {
    field: 'lesson_step_check',
    legend: '8.4. Проверять каждый шаг или нет',
    prompt: 'Как удобнее идти по задаче:',
    options: LESSON_CHECK_OPTIONS,
  },
  {
    field: 'lesson_speak',
    legend: '8.5. Вслух или молча',
    prompt: 'На занятии обычно легче:',
    options: LESSON_SPEAK_OPTIONS,
  },
  {
    field: 'lesson_praise',
    legend: '8.6. Поддержка и похвала',
    prompt: 'Что ближе:',
    options: LESSON_PRAISE_OPTIONS,
  },
  {
    field: 'lesson_tone',
    legend: '8.7. Тон преподавателя',
    prompt: 'Какой тон комфортнее:',
    options: LESSON_TONE_OPTIONS,
  },
  {
    field: 'homework_incomplete',
    legend: '8.8. Недоделанное ДЗ',
    prompt: 'Если ДЗ не успели сделать целиком:',
    options: HOMEWORK_INCOMPLETE_OPTIONS,
  },
];

export const EMPTY_QUESTIONNAIRE = {
  goal: '',
  goal_other: '',
  ege_year: '',
  ege_year_other: '',
  target_score: '',
  programming_experience: '',
  school_informatics_experience: '',
  homework_attitude: '',
  workload: '',
  group_attitude: '',
  finance: '',
  lesson_wait: '',
  lesson_think_time: '',
  lesson_spoil: '',
  lesson_step_check: '',
  lesson_speak: '',
  lesson_praise: '',
  lesson_tone: '',
  homework_incomplete: '',
  comment: '',
};

export const GROUP_LESSONS_EXPLANATION =
  'В каждый момент времени я общаюсь только с одним учеником. Ученики общаются всегда только со мной. '
  + 'Исключительно индивидуальный план для каждого ученика, никаких совместных заданий. '
  + 'Переключаться могу за счёт того, что ученику нужно дать время подумать над задачей. '
  + 'На случай, если ученику нужна помощь, а я занят с другим учеником, есть специальные мини-задания для каждого занятия.';

export const WORK_STYLE_HINT =
  'Это не тест и не оценка. Ответьте, как обычно удобнее — так проще подобрать тон занятий. Потом можно поменять.';

export function needsEgeDetails(goal) {
  return goal === 'ege' || goal === 'oge_ege';
}

export function optionLabel(options, value) {
  if (!value) return '—';
  const found = options.find((o) => o.value === value);
  return found ? found.label : value;
}

export function hasIncompleteWorkStyle(form) {
  return WORK_STYLE_FIELDS.some((field) => !form?.[field]);
}

/**
 * Короткие подсказки преподавателю по ответам блока 8.
 * Не «тип личности», а настройки режима на занятии.
 */
export function buildWorkStyleTips(data) {
  if (!data) return [];
  const tips = [];

  if (data.lesson_wait === 'need_focus' && data.lesson_think_time === 'together_asap') {
    tips.push('В группу — только с короткими паузами; иначе лучше индивидуал.');
  } else if (data.lesson_wait === 'need_focus') {
    tips.push('Тяжело ждать переключений — короткие паузы или индивидуал.');
  } else if (data.lesson_wait === 'ok_short') {
    tips.push('Паузы ок, но не затягивать переключения.');
  }

  if (data.lesson_spoil === 'want_self' && data.lesson_think_time === 'long_silence') {
    tips.push('Не срывать решение: спросить «подсказка или ещё минута?»');
  } else if (data.lesson_think_time === 'long_silence') {
    tips.push('Давать больше тишины на размышление.');
  } else if (data.lesson_think_time === 'together_asap') {
    tips.push('Быстрее разбирать вместе — долгая тишина застревает.');
  }

  if (data.lesson_spoil === 'want_self') {
    tips.push('Важно дойти самому — не опережать с объяснением.');
  } else if (data.lesson_spoil === 'prefer_explain') {
    tips.push('Объяснение раньше — нормально, сам крутится впустую.');
  }

  if (data.lesson_step_check === 'each_step') {
    tips.push('Чаще сверка по шагам, меньше «сам до конца».');
  } else if (data.lesson_step_check === 'alone_end') {
    tips.push('Дать поработать самому; проверять в конце или по запросу.');
  } else if (data.lesson_step_check === 'plan_then') {
    tips.push('Сначала вместе план, дальше самостоятельная работа.');
  }

  if (data.lesson_speak === 'aloud') {
    tips.push('Просить думать голосом.');
  } else if (data.lesson_speak === 'write_min') {
    tips.push('Минимум разговора — опираться на письмо/печать.');
  } else if (data.lesson_speak === 'silent_then') {
    tips.push('Не тянуть разговор, пока сам не сформулирует мысль.');
  }

  if (data.lesson_praise === 'only_real' || data.lesson_praise === 'concrete') {
    tips.push('Конкретная обратная связь, без общего «молодец».');
  } else if (data.lesson_praise === 'encourage') {
    tips.push('Подбадривать и за небольшие шаги.');
  }

  if (data.lesson_tone === 'dry') {
    tips.push('Без шуток и бодрости в первые занятия.');
  } else if (data.lesson_tone === 'calm') {
    tips.push('Спокойный ровный тон, без лишнего веселья.');
  } else if (data.lesson_tone === 'lively') {
    tips.push('Живой тон и шутки ок, если не сбивают с задачи.');
  }

  if (data.homework_incomplete === 'finish_later') {
    tips.push('Не давать растянутое ДЗ «на вырост» — тяжело бросить кусок.');
  } else if (data.homework_incomplete === 'may_drop') {
    tips.push('Маленькие порции ДЗ и дедлайн «как есть».');
  } else if (data.homework_incomplete === 'send_partial') {
    tips.push('Ок принимать частичное ДЗ с пометкой, где застрял.');
  }

  return tips;
}

export function questionnaireFromApi(data) {
  if (!data || typeof data !== 'object' || data.filled === false) {
    return { ...EMPTY_QUESTIONNAIRE };
  }
  const next = { ...EMPTY_QUESTIONNAIRE };
  Object.keys(EMPTY_QUESTIONNAIRE).forEach((key) => {
    next[key] = data[key] ?? '';
  });
  return next;
}
